import config from 'config';
import { ListPayload, ListResponse } from 'core/http/response';
import axiosClient from '../../config/axios';
import { Exchange } from './exchange';

export const listExchange = (): Promise<ListPayload<Exchange>> =>
    axiosClient
        .get<ListResponse<Exchange>>(`${config.cmsUrl}/exchanges/available`)
        .then((response) => response.data.payload);
